<template>
    <vx-table-row>
        <vx-table-row-title>
            <div class="flex items-center">
                <div
                    class="w-4 h-4 rounded-full mr-2 shrink-0"
                    :class="props.item.has_errors ? 'bg-rose-400' : 'bg-emerald-400'"
                ></div>
                <span class="font-normal">{{ props.item.has_errors ? 'Error' : 'Success' }}</span>
            </div>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Received: </template>

            <vx-popover hover :arrow="true" placement="top" :key="createdAtKey">
                {{ fromNow(props.item.timestamp) }}
                <template v-slot:content>
                    {{ shortDateTime(props.item.timestamp) }}
                </template>
            </vx-popover>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Vendor: </template>
            <vx-badge size="xs" color="slate">{{ vendorLabel }}</vx-badge>
        </vx-table-row-item>

        <vx-table-row-buttons>
            <vx-button
                class="w-full md:w-auto"
                :href="`/settings/integrations/${props.item.vendor}/logs/entry?${stringifyQueryString({
                    ptr: props.item.ptr ?? '',
                })}`"
                color="muted"
                outline
            >
                Details
                <font-awesome-icon widthAuto :icon="faArrowRight" />
            </vx-button>
        </vx-table-row-buttons>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { stringifyQueryString } from '~/utils/string';
import {
    VxButton,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
    VxBadge,
    VxPopover,
} from '@voxie/frontend-components';
import { useInterval } from '@vueuse/core';
import { computed } from 'vue';
import { fromNow, shortDateTime } from '~/utils/date';
import type { IntegrationLogListItem } from '~/services/integrationLogsClient';

const props = defineProps<{
    item: IntegrationLogListItem;
}>();

const vendorLabels: Record<string, string> = {
    acuity: 'Acuity',
    amplitude: 'Amplitude',
    calendly: 'Calendly',
    revel: 'Revel',
};

const vendorLabel = computed(() => vendorLabels[props.item.vendor] ?? props.item.vendor);

const createdAtKey = useInterval(60000);
</script>
